import React from 'react';
import classNames from 'classnames';
import cls from './HintEmptyEstimate.module.css';
import { useHintEmptyEstimate } from './useHintEmptyEstimate';

interface HintEmptyEstimateProps {
    classes?: string;
    status: string;
    isCustomer: boolean;
}

export const HintEmptyEstimate = ({ classes, status, isCustomer }: HintEmptyEstimateProps) => {
    const { is_customer } = useHintEmptyEstimate();

    return (
        <div className={classNames(cls.HintEmptyEstimate, [classes])}>
            <div className={cls.Text}>
                <span>
                    {i18next.t('HintEmptyEstimate.return.text.part1')}
                    {is_customer && status === 'inDraft' && ','}
                </span>
                {is_customer && status === 'inDraft' ? (
                    <span> {i18next.t('HintEmptyEstimate.return.text.part2')}</span>
                ) : (
                    <span>
                        {i18next.t('HintEmptyEstimate.return.text.inStatus')} «
                        {status === 'inDraft'
                            ? i18next.t('HintEmptyEstimate.return.text.inDraft')
                            : i18next.t('HintEmptyEstimate.return.text.inProgress')}
                        »
                    </span>
                )}
            </div>
        </div>
    );
};
